export default "__VITE_PUBLIC_ASSET__53f47e52__"